<div [routerLink]="isClickable ? ['/strategies',selectedStrategyId,'indicators',indicator.id] : null" 
     [class.non-clickable]="!isClickable"
     class="indicator-card"
     (mouseenter)="onMouseEnter(indicator.id)" (mouseleave)="onMouseLeave()">
    
    <!-- Modern Card Design -->
    <div [class.cursor-pointer]="isClickable" 
         class="relative bg-white border-round-2xl border-2 border-primary/20 shadow-4 hover:shadow-6 transition-all duration-300 overflow-hidden h-20rem">
        
        <!-- Gradient Background -->
        <div class="absolute inset-0 bg-gradient-to-br from-primary/5 to-cyan-500/5"></div>
        
        <!-- Header Section -->
        <div class="relative z-10 p-4 border-bottom-1 border-primary/10">
            <div class="flex align-items-center justify-content-between mb-3">
                <div class="flex align-items-center gap-2">
                    <div class="bg-primary text-white px-3 py-1 border-round-lg font-bold text-sm">
                        {{indicator.code}}
                    </div>
                    <div class="text-primary text-sm font-semibold">
                        {{indicator.pillar_name}}
                    </div>
                </div>
                <div class="text-primary text-2xl">
                    <i class="fa-solid fa-chart-line"></i>
                </div>
            </div>
            
            <h3 class="font-bold text-lg text-primary-dark m-0 line-height-3">
                {{indicator.name}}
            </h3>
        </div>

        <!-- Content Section -->
        <div class="relative z-10 p-4 flex-1">
            <div *ngIf="!(indicator.id==hoverIndicatorId)" class="h-full flex flex-column gap-3">
                
                <!-- Measurement Cycle -->
                <div class="flex align-items-center gap-2">
                    <i class="fa-solid fa-repeat text-primary"></i>
                    <span class="text-sm font-semibold text-gray-600">{{"kpi_cycle"|translate}}:</span>
                    <span class="text-sm text-primary font-bold">{{indicator.measurement_cycle_ar}}</span>
                </div>

                <!-- Responsible Person -->
                <div class="flex align-items-center gap-2">
                    <i class="fa-solid fa-user text-primary"></i>
                    <span class="text-sm font-semibold text-gray-600">{{"responsible"|translate}}:</span>
                    <span class="text-sm text-primary font-bold">{{indicator.in_charge_name}}</span>
                </div>

                <!-- Target Value -->
                <div class="flex align-items-center gap-2">
                    <i class="fa-solid fa-bullseye text-primary"></i>
                    <span class="text-sm font-semibold text-gray-600">{{"target"|translate}}:</span>
                    <span class="text-sm text-primary font-bold">
                        @if(indicator.measurement_unit == "percentage"){
                            {{indicator.target}}%
                        }@else{
                            {{indicator.target}}
                        }
                    </span>
                </div>

                <!-- Date Range -->
                <div class="flex align-items-center gap-2">
                    <i class="fa-solid fa-calendar text-primary"></i>
                    <span class="text-sm font-semibold text-gray-600">{{"date"|translate}}:</span>
                    <div class="flex align-items-center gap-1 text-sm text-primary font-bold">
                        <span>{{indicator.start_date|date:'yyyy/MM/dd'}}</span>
                        <i class="fa-solid fa-arrow-left text-xs"></i>
                        <span>{{indicator.end_date|date:'yyyy/MM/dd'}}</span>
                    </div>
                </div>
            </div>

            <!-- Hover Description -->
            <div *ngIf="indicator.id==hoverIndicatorId" class="h-full">
                <div class="flex align-items-center gap-2 mb-3">
                    <i class="fa-solid fa-info-circle text-primary"></i>
                    <span class="font-bold text-primary">{{"description"|translate}}:</span>
                </div>
                <div class="text-sm text-gray-700 line-height-4">
                    {{indicator.description}}
                </div>
            </div>
        </div>

        <!-- Hover Effect Overlay -->
        <div class="absolute inset-0 bg-primary/5 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
    </div>
</div>